module.exports = __webpack_public_path__ + "img/icon4.8cf121b1.png";